import { Component, ElementRef, Input, ViewChild } from '@angular/core'
import { InlineEditCellDirective } from '../inline-edit-cell'
import { Calendar } from 'primeng/calendar'

@Component({
  selector: 'jml-lib-date-period-cell',
  templateUrl: './date-period-cell.component.html',
  styleUrls: ['../inline-edit-cell.scss']
})
export class DatePeriodCellComponent extends InlineEditCellDirective {
  @Input() tableReference: ElementRef
  @ViewChild('calendarRef') calendarRef: Calendar

  override minWidthPx = 230
  private keydownListener: ((e: KeyboardEvent) => void) | null = null

  de = {
    firstDayOfWeek: 1,
    dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    dayNamesMin: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
    monthNames: [
      'Januar',
      'Februar',
      'März',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'Okotober',
      'November',
      'Dezember'
    ],
    monthNamesShort: ['Jan', 'Feb', 'Mrz', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
    today: 'Heute',
    clear: 'Verwerfen'
  }

  triggerEdit() {
    this.originalContent = this.rowData[this.fieldName]
    this.isEdited = true
    this.tableReference?.nativeElement
      .querySelector('div.p-datatable-scrollable-body')
      ?.addEventListener('scroll', (ev: Event) => this.abortCellEdit(null), { once: true })
    setTimeout(() => this.attachEnterKeyListener())
  }

  onDateSelect() {
    const datePeriod = this.rowData[this.fieldName]
    if (datePeriod[0] && datePeriod[1]) {
      this.save()
    }
  }

  save() {
    this.isEdited = false
    this.completeCellEdit.emit({ data: this.rowData, field: this.fieldName })
  }

  private attachEnterKeyListener() {
    if (this.calendarRef?.inputfieldViewChild?.nativeElement) {
      this.keydownListener = (e: KeyboardEvent) => {
        if (e.key === 'Enter') {
          const datePeriod = this.rowData[this.fieldName]
          if (datePeriod && (!this.mandatory || datePeriod[1]) && (!datePeriod[0] || datePeriod[1])) {
            this.save()
          }
        }
      }

      this.calendarRef.inputfieldViewChild.nativeElement.addEventListener('keydown', this.keydownListener, true)
    }
  }
}
